import React from 'react';
import { StyledEngineProvider, ThemeProvider, ThemeOptions } from '@mui/material/styles';
import { StylesProvider, createGenerateClassName } from '@mui/styles';
import { createTheme } from 'smartstream-widgets/theme/GeniusSportsTheme';
import { CacheProvider } from '@emotion/react'
import { Enhancer } from 'widgets-shared/core';
import createEmotionCache from 'smartstream-widgets/utils/createCache';

const cache = createEmotionCache()

type Props = {
  config: {
    partialTheme: ThemeOptions;
    useNewBrandingTheme?: boolean;
    jssPrefix?: string;
    seed?: string;
  };
};

export const withMuiThemeProvider: Enhancer = (ComposedComponent) => (props: Props) => {
  //  We have to provide theme differently, server-side
  if (typeof window === 'undefined') return <ComposedComponent {...props} />;

  const { partialTheme, jssPrefix, seed, useNewBrandingTheme = false } = props.config;
  const theme = createTheme(partialTheme, useNewBrandingTheme);

  return (
    <CacheProvider value={cache}>
      <StylesProvider
        generateClassName={createGenerateClassName({
          productionPrefix: jssPrefix,
          seed: seed,
        })}
      >
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <ComposedComponent {...props} />
          </ThemeProvider>
        </StyledEngineProvider>
      </StylesProvider>
    </CacheProvider>
  );
};
